import getMomentDateObj from "./getMomentDateObj"
import sortPerformancesByDate from "./sortPerformancesByDate"

const getFirstCurrentPerformanceByTime = (now, performances, timezone, offset = 10) => {
    const performancesSortedByDate = sortPerformancesByDate(performances)

    return performancesSortedByDate.find(performance => now.isSameOrBefore(getMomentDateObj(performance.timeUtc, timezone).add(offset, 'minutes')))
}

export default getFirstCurrentPerformanceByTime